import { FullScreenTransition } from "components/full-screen-transition/full-screen-transition";
import React, { useEffect } from "react";
import { sitemap } from "sitemap";
import { useGlobalState } from "utilities/contexts/use-global-state-context";
import { useNavigate } from "utilities/hooks/navigation/use-navigate";

const AzureLogoutPage: React.FC = () => {
    const { record: globalState, setRecord: setGlobalState } = useGlobalState();
    const navigate = useNavigate();
    const isAuthenticated = globalState.isAuthenticated();
    const [navigatingToLogin, setNavigatingToLogin] = React.useState(false);

    useEffect(() => {
        if (isAuthenticated) {
            setGlobalState((currentState) => currentState.setUnauthenticated());
        }
    }, [isAuthenticated, setGlobalState]);

    useEffect(() => {
        if (!isAuthenticated && !navigatingToLogin) {
            setNavigatingToLogin(true);
            navigate(sitemap.public.userLogin, { replace: true });
        }
    }, [isAuthenticated, navigatingToLogin, navigate]);


    return <FullScreenTransition transitionText="Logging Out" />;
};

export { AzureLogoutPage };
